import get from 'lodash.get'
import { fetchJSON } from './common'

export async function geolocate() {
  const json = await fetchJSON(`${process.env.REACT_APP_GOOGLE_GEOLOCATION_URL}?key=${process.env.REACT_APP_GOOGLE_API_TOKEN}`, {
    method: 'post',
    body: { considerIp: true },
  })
  return get(json, 'location', {})
}

export async function geocode(address, geocodeKey = 'address') {
  const json = await fetchJSON(
    `${process.env.REACT_APP_GOOGLE_GEOCODING_URL}?${geocodeKey}=${encodeURIComponent(address)}&key=${process.env.REACT_APP_GOOGLE_API_TOKEN}`
  )

  return {
    location: get(json, 'results[0].geometry.location', {}),
    viewPort: get(json, 'results[0].geometry.viewport', {}),
  }
}



// WEBPACK FOOTER //
// ./src/services/geolocation.js